import styled from 'styled-components/macro';

import Button from 'components/Button/Button';
import Popup from 'components/Popup/Popup';
import Typography from 'components/Typography/Typography';

export const EulaPopupStyled = styled(Popup)`
  // use your custom style for ".popup-overlay"
  &-overlay {
  }
  // use your custom style for ".popup-content"
  &-content {
    position: fixed;
    width: 100%;
    height: 80%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px 10px;
  }
`;

export const TypographyTitleStyled = styled(Typography)`
  width: 50%;
  margin-bottom: 1.875rem;
`;

export const TypographyContentStyled = styled(Typography)`
  width: 50%;
  margin-bottom: 1.875rem;
`;

export const EulaButtonStyled = styled(Button)`
  height: 48px;
  flex: 1 1;
  font-size: ${({ theme }): string => theme.fontSize['2xl']};

  &:first-child {
    margin-right: 1rem;
  }

  ${({ theme }): string => {
    return `
    ${theme.devices.tablet} {
        height: 38px;
        font-size: ${theme.fontSize.lg};
    }
    `;
  }}
`;
